import { render, staticRenderFns } from "./CostPrice.vue?vue&type=template&id=0300b950"
import script from "./CostPrice.vue?vue&type=script&lang=js"
export * from "./CostPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports